<template>
  <div v-if="form.errors.has(field)" class="form-text invalid-feedback" v-html="form.errors.get(field)"/>
</template>

<script>
export default {
  name: 'FormError',
  props: {
    form: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/FormError.vue